import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import _ from 'underscore'

import AppClass from './../../../../../../../../../js/classes/App.js'
import OrderClass from './../../../../../../../../../js/classes/Order.js'

import DataContext from '../../contexts/data.jsx'

import DeliveryItem from './Item.jsx'
import DeliveryFields from './Fields.jsx'
import DeliveryStores from './Stores.jsx'
import SelectLocation from './SelectLocation.jsx'
import PickPoints from './PickPoints.jsx'

const DeliveryStep = ({ setData, forceRender }) => {
    const [ selectPickPointCode, setSelectPickPointCode ] = useState(null)

    let defaultDelivery = null,
    deliveryShowsIDs = []

    const data = useContext(DataContext),
    handleChangeDelivery = (delivery) => {
        const newContextData = Object.assign({}, data)

        newContextData.delivery.id = parseInt(delivery.ID) || null

        setData(newContextData)
    },
    checkDeliveryPrice = (delivery) => {
        //if (delivery.PRICE === null) {
            if (data.payments.id > 0 && delivery.ID > 0 && data.data.current_location && data.data.current_location.ID > 0 && data.contacts.person > 0) {
                delivery.PRICE = null
                delivery._IS_LOADING = true

                OrderClass.getDeliveryCalculate((err, res) => {
                    if (err) {
                        delivery._ERRORS = err
                        delivery._IS_LOADING = true
                    } else {
                        if (res.PRICE >= 0) {
                            delivery._IS_LOADING = true
                            delivery._ERRORS = null
                            delivery.PRICE = res.PRICE
                            delivery.PERIOD = res.PERIOD
                        }

                        forceRender((new Date()).getTime())
                    }
                }, {
                    DELIVERY_ID : delivery.ID, 
                    LOCATION_ID : data.data.current_location.ID,
                    PAYMENT_ID : data.payments.id,
                    PERSON_TYPE_ID : data.contacts.person,
                    ZIP : data.contacts.zip || '',
                })
            }
        //}
    },
    checkRestriction = (delivery) => {
        const deliveryRestriction = data.data.restrictions.DELIVERY[delivery.ID]

        if (delivery.ACTIVE && deliveryRestriction) {
            //Locations
            if (
                deliveryRestriction.LOCATIONS && 
                deliveryRestriction.LOCATIONS.length > 0
            ) {
                if (deliveryRestriction.LOCATIONS.indexOf(data.data.current_location && data.data.current_location.ID) === -1) {
                    return false
                }
            }

            //Exclude locations
            if (
                deliveryRestriction.EXCLUDE_LOCATIONS && 
                deliveryRestriction.EXCLUDE_LOCATIONS.length > 0
            ) {
                if (deliveryRestriction.EXCLUDE_LOCATIONS.indexOf(data.data.current_location && data.data.current_location.ID) !== -1) {
                    return false
                }
            }
            
            //Persons
            if (
                deliveryRestriction.PERSONS && 
                deliveryRestriction.PERSONS.length > 0
            ) {
                if (deliveryRestriction.PERSONS.indexOf(data.contacts.person) === -1) {
                    return false
                }
            }

            //Payments
            /*
            if (
                deliveryRestriction.PAYMENTS && 
                deliveryRestriction.PAYMENTS.length > 0
            ) {
                if (deliveryRestriction.PAYMENTS.indexOf(data.payments.id) === -1) {
                    return false
                }
            }
            */
        }

        if (!defaultDelivery) {
            defaultDelivery = delivery
        }

        deliveryShowsIDs.push(delivery.ID)

        if (delivery._IS_LOADING !== true) {
            checkDeliveryPrice(delivery)
        }

        return true
    },
    handleChangeLocation = () => {
        AppClass.runCallback('select_location_show', true, true)
    }

    useEffect(() => {
        AppClass.addCallback('SELECT_DELIVERY_PVZ', (service, point) => {
            if (!service || !point) {
                setSelectPickPointCode(null)
            }

            const newContextData = Object.assign({}, data),
            keys = Object.keys(newContextData.delivery_pick_points)
            
            keys.forEach((key) => {
                const pickPoint = newContextData.delivery_pick_points[key]

                if (pickPoint && pickPoint.TYPE === service) {
                    newContextData.delivery_pick_points[key].VALUE = point
                } else {
                    newContextData.delivery_pick_points[key].VALUE = null
                }
            })

            setData(newContextData)

            setSelectPickPointCode(null)
        })

    }, [])
    
    useEffect(() => {
        if (!data.delivery.id && defaultDelivery) {
            handleChangeDelivery(defaultDelivery)
        }

        AppClass.addCallback('select_location_change', (location) => {
            const newContextData = Object.assign({}, data)

            if (location) {
                newContextData.data.current_location = {
                    ID : parseInt(location.ID),
                    CITY : location.NAME
                }
            } else {
                newContextData.data.current_location = null
            }

            newContextData.data.delivery.map((delivery) => {
                if (delivery._IS_LOADING) {
                    delivery.PRICE = null
                    delivery._IS_LOADING = false
                }

                return delivery
            })

            setData(newContextData, () => {
                forceRender()
            })
        })
    }, [])

    useLayoutEffect(() => {
        if (deliveryShowsIDs.length > 0) {
            if (data.delivery.id > 0) {
                if (deliveryShowsIDs.indexOf(data.delivery.id) === -1) {
                    handleChangeDelivery(data.data._delivery[deliveryShowsIDs[0]])
                }
            } else if (data.data._delivery[deliveryShowsIDs[0]]) {
                handleChangeDelivery(data.data._delivery[deliveryShowsIDs[0]])
            }
        }
    })

    return <div className="happy-order__step happy-order__step_delivery">
        <div className="happy-order__step-header">
            <h2 className="happy-order__step-title">Шаг 2. Доставка в <SelectLocation handleChangeLocation={ handleChangeLocation } data={ data } setData={ setData } /></h2>

            <div className="happy-order__step-notice">
                Убедитесь, что правильно введен населённый пункт — от этого зависят доступные виды доставки и стоимость
            </div>
        </div>

        <div className="happy-order__delivery-list">
            { data.data.delivery.map((delivery) => {
                return checkRestriction(delivery) ? <DeliveryItem
                    key={ `delivery-item-${ delivery.ID }` }
                    delivery={ delivery }
                    data={ data }
                    handleChangeDelivery={ handleChangeDelivery }
                    handleSelectPickPoint={ () => setSelectPickPointCode( data?.delivery_pick_points[delivery.ID]?.TYPE ) }
                /> : null
            }) }
        </div>

        { (data.delivery.id && data.data._delivery[data.delivery.id]) ? <>
            <DeliveryStores
                delivery={ data.data._delivery[data.delivery.id] }
                data={ data }
                setData={ setData }
            />
            <DeliveryFields
                delivery={ data.data._delivery[data.delivery.id] }
                setData={ setData }
            />
        </> : null}

        { selectPickPointCode && <PickPoints
            deliveryCode={ selectPickPointCode }
        /> }
    </div>
}

export default DeliveryStep